"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useClickOutside = (onClickOutside) => {
    const containerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const handleMouseUp = (event) => {
            if (containerRef &&
                !(containerRef.current instanceof Element &&
                    containerRef.current.contains(event?.target))) {
                onClickOutside(event);
            }
        };
        window.document.addEventListener('mouseup', handleMouseUp);
        return () => window.document.removeEventListener('mouseup', handleMouseUp);
    }, [containerRef, onClickOutside]);
    return containerRef;
};
exports.default = useClickOutside;
